
export interface TierFeatures {
  name: string;
  price: { monthly: number; annual: number };
  features: {
    dailyExerciseLimit: number | 'unlimited';
    aiWritingEvaluations: number | 'unlimited';
    aiSpeakingEnhancement: number | 'unlimited';
    mockTests: number | 'unlimited';
    advancedModules: boolean;
    memoryPalace: boolean;
    adaptiveDifficulty: boolean;
    downloadReports: boolean;
    prioritySupport: boolean;
    oneOnOneCoaching: boolean;
    bandGuarantee: boolean;
  };
  badge: {
    icon: string;
    color: string;
  };
}

export const SUBSCRIPTION_TIERS: Record<string, TierFeatures> = {
  free: {
    name: 'Recruit',
    price: { monthly: 0, annual: 0 },
    features: {
      dailyExerciseLimit: 5,
      aiWritingEvaluations: 0,
      aiSpeakingEnhancement: 0,
      mockTests: 0,
      advancedModules: false,
      memoryPalace: false,
      adaptiveDifficulty: false,
      downloadReports: false,
      prioritySupport: false,
      oneOnOneCoaching: false,
      bandGuarantee: false
    },
    badge: { icon: '🎯', color: '#9ca3af' }
  },
  premium: {
    name: 'Elite Warrior',
    price: { monthly: 29, annual: 199 },
    features: {
      dailyExerciseLimit: 'unlimited',
      aiWritingEvaluations: 10,
      aiSpeakingEnhancement: 'unlimited',
      mockTests: 5,
      advancedModules: true,
      memoryPalace: true,
      adaptiveDifficulty: true,
      downloadReports: true,
      prioritySupport: false,
      oneOnOneCoaching: false,
      bandGuarantee: false
    },
    badge: { icon: '⚡', color: '#C5A059' }
  },
  elite: {
    name: 'Commander',
    price: { monthly: 99, annual: 799 },
    features: {
      dailyExerciseLimit: 'unlimited',
      aiWritingEvaluations: 'unlimited',
      aiSpeakingEnhancement: 'unlimited',
      mockTests: 'unlimited',
      advancedModules: true,
      memoryPalace: true,
      adaptiveDifficulty: true,
      downloadReports: true,
      prioritySupport: true,
      oneOnOneCoaching: true,
      bandGuarantee: true
    },
    badge: { icon: '👑', color: '#ef4444' }
  }
};
